<div class="m-auto mt-5 col-11">
    <h2>Modulistica</h2>
    <div>
        <div class="list-group mt-5" *ngFor="let doc of documenti">
            <div class="list-group-item list-group-item-action py-4 cur" (click)="openDoc(doc.type)">{{doc.titolo}}
            </div>
        </div>
    </div>
</div>